// EkBharatShreshthaBharat
import React from 'react';

import ClassLeaderElection2024 from 'views/ClassLeaderElection2024';

const EkBharatShreshthaBharatPage = () => {
  return <ClassLeaderElection2024 />;
};

export default EkBharatShreshthaBharatPage;